import { lazy, Suspense } from 'react';

import { ONBOARDING_FEATURE_ENABLED } from '../api/onboarding/config';
import RequirePermission from '../components/AuthGuards/RequirePermission';
import { PageName } from '../constants/routes.constants';

const LicensorOnboarding = lazy(() => import('../pages/LicensorOnboarding'));

// Registered only when REACT_APP_ENABLE_ONBOARDING=true; otherwise the route does
// not exist and the rest of the app is unaffected.
export const OnboardingRoutes = ONBOARDING_FEATURE_ENABLED
  ? [
      {
        path: PageName.LICENSOR_ONBOARDING,
        // Was reachable by unauthenticated visitors (the flag was the only
        // gate). licensor.profile.write: only cw-platform-admin and lic-admin
        // hold it - the two roles that may configure a licensor.
        element: (
          <RequirePermission permission="licensor.profile.write">
            <Suspense fallback={<></>}>
              <LicensorOnboarding />
            </Suspense>
          </RequirePermission>
        ),
      },
    ]
  : [];
